/**
 * @file: 查询文本框插入对象
 * @author: xiaolong.huang@dmall.com
 */

import * as CubeTree from '../../../cubeTree/index';

/**
 * 查询顺序
 *
 * 1. 层板
 * 2. 商品、文本框
 * 3. 画布
 */
function textareaTarget(allSelected: Array<CubeId>): Array<CubeId> {
    let result: Set<CubeId> = new Set();

    // 先找层板
    allSelected.forEach((target: CubeId): void => {
        if (CubeTree.canDropGoods(target)) {
            result.add(target);
        }
    });

    // 再找商品和文本框，此时需要判断商品的父级是否能在 partitionList 中找到，如果可以找到的话，就过滤掉
    allSelected.forEach((target: CubeId): void => {
        let parentId: CubeId = CubeTree.findParentIdByCubeId(target);

        if ((CubeTree.isGoods(target)
            || CubeTree.isTextarea(target)
            || CubeTree.isBafflePlate(target))
            && !result.has(parentId)) {
            result.add(target);
        }
    });

    if (!result.size) {
        result.add(CubeTree.findSketchpad());
    }

    return Array.from(result);
}

export {
    textareaTarget
};
